'use client';

import { ErrorTemplate } from '~/app/_components/ErrorTemplate';
import { pagesPath } from '~/libs/$path';

interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

export default function ErrorPage({
  error: _error,
  reset: _reset,
}: ErrorPageProps) {
  return (
    <ErrorTemplate
      title='エラーが発生しました'
      description='申し訳ありません。予期せぬエラーが発生しました。以下のオプションから操作を選択してください。'
      links={[
        { label: 'ホームへ戻る', url: pagesPath.$url().path },
        { label: 'お問い合わせ', url: pagesPath.contact.$url().path },
      ]}
      showLogout
    />
  );
}
